<ng-container *transloco="let t; read: 'attachments'">
    <ng-container *ngIf="vm$ | async as vm">
        <div>
            <div class="mbm" [hidden]="readonly || !('Permissions.Attachments.Create' | permission)">
                <fieldset>
                    <div class="flex-row alignCenter mbs">
                        <h2>{{ uploadTitle || t('uploadAttachments') }}</h2>
                        <span  class="tooltipContainer">
                            <span [attr.tooltip]="t('upload.tooltip')" flow="right" class="tooltipContainer">
                                <img class="tooltipIcon" src="../../../assets/icons/information-icon.svg">
                            </span>
                        </span>
                    </div>

                    <kendo-upload
                        kendoButton
                        loadingIndication="/attachment/uploadAttachment"
                        (upload)="uploadAttachment($event)"
                        [ngClass]="{ 'uploading': vm.isUploading }"
                        [batch]="true"
                        [restrictions]="restrictions">
                            <kendo-upload-messages
                                [dropFilesHere]="t('upload.dropZone')"
                                [select]="vm.isUploading ? '&#x21bb;' : t('upload.button')">
                            </kendo-upload-messages>
                    </kendo-upload>
                </fieldset>
            </div>

            <fieldset *ngIf="vm.documents.length > 0">
                <div>
                    <h2>{{ t('documents') }}</h2>
                </div>
                <div class="attachmentList">
                    <div *ngFor="let document of vm.documents" class="attachmentItem">             
                        <img *ngIf="thumbnailCache.getUrl(document.id) as thumbUrl" [src]="thumbUrl" class="attachmentThumbnail" />
                        <span class="attachmentTitle">{{ document.fileName }}</span>

                        <div class="attachmentActions">
                            <a class="shareIcon" (click)="openPreview(document.id, document.fileName)">
                                <img src="../../../assets/icons/share.svg">
                            </a>
    
                            <a class="downloadIcon" (click)="downloadAttachment(document.id, document.fileName)">
                                <img src="../../../assets/icons/download.svg">
                            </a>
    
                            <a class="deleteIcon" (click)="documentDeletionDialogOpen(document.id)"
                                [hidden]="readonly || !('Permissions.Attachments.Delete' | permission)">
                                <img src="../../../assets/icons/delete-icon.svg">
                            </a>
                        </div>
                    </div>
                </div>
            </fieldset>

        </div>

        <app-delete-confirm-dialog
            [opened]="documentDeletionDialogOpened"
            [message]="t('deletionMessage')"
            (confirmed)="documentDeletionDialogClose('delete')"
            (cancelled)="documentDeletionDialogClose('cancel')"
        ></app-delete-confirm-dialog>
    </ng-container>
</ng-container>

<kendo-window
  *ngIf="previewOpen"
  [title]="previewFileName"
  (close)="closePreview()"
  [minWidth]="400"
  [minHeight]="300"
  [resizable]="true"
  [draggable]="true">
  
  <div class="preview-container">

    <div class="preview-content">
      <ng-container *ngIf="previewIsPdf; else imagePreview">
        <kendo-pdfviewer
          [url]="previewBlobUrl"
          [tools]="pdfViewerTools"
          style="width: 100%; height: calc(100% - 50px);">
        </kendo-pdfviewer>
      </ng-container>

      <ng-template #imagePreview>
        <img [src]="previewBlobUrl" class="preview-image" />
      </ng-template>

      <div class="preview-toolbar">
        <button kendoButton themeColor="primary" (click)="downloadAttachment(previewId, previewFileName)">Download</button>
      </div>
    </div>
  </div>
</kendo-window>